var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVotaVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.17,
    height: 86.17,
    viewBox: "0 0 86.17 86.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10125",
    "data-name": "Raggruppa 10125",
    transform: "translate(-197.382 -254.017)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1814",
    "data-name": "Ellisse 1814",
    cx: 43.085,
    cy: 43.085,
    r: 43.085,
    transform: "translate(197.382 254.017)",
    fill: "#82bc03"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10107",
    "data-name": "Raggruppa 10107",
    transform: "translate(0.534 15.734)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1819",
    "data-name": "Ellisse 1819",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(204.057 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1820",
    "data-name": "Ellisse 1820",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(261.503 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1821",
    "data-name": "Ellisse 1821",
    cx: 28.374,
    cy: 29.584,
    rx: 28.374,
    ry: 29.584,
    transform: "translate(211.907 251.783)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16092",
    "data-name": "Tracciato 16092",
    d: "M224.614,283.917a2.332,2.332,0,0,1,2.294-2.368,2.292,2.292,0,1,1-2.294,2.369Z",
    fill: "#2a3a90",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32550",
    "data-name": "Tracciato 32550",
    d: "M249.62,294.549a9.284,9.284,0,0,1-9.339,6.807,9.5,9.5,0,0,1-9.463-6.807",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32551",
    "data-name": "Tracciato 32551",
    d: "M257.2,285.064a3.512,3.512,0,0,0-3.518-2.6,3.593,3.593,0,0,0-3.565,2.6",
    transform: "translate(0.534 15.734)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotaVerde);
export default __webpack_public_path__ + "static/media/vota-verde.f6f26521d7e39974bfeba02d3f025af3.svg";
export { ForwardRef as ReactComponent };